import React, { useState, useEffect } from 'react'

const Index = () => {
  const img =  require("../../../images/template_help.png");
  const interview_img =  require("../../../images/help_template_interview.png");

  const exsamples = [
    {title: "誰に対してアンケートをとりたいのか考える", descripts: ["男性に対してアンケートを取りたい"], button: {name: null, url: null}},
    {title: "何を聞きたいのか考える", descripts: ["生年月日を聞きたい", "→質問登録画面で「生年月日を入力してください」という質問を作成する"], button: {name: "質問を作成・編集する", url:"/parts/index"}},
    {title: "考えた質問をカテゴリごとに分ける", descripts: ["「生年月日」という質問は基本情報の聞き取りである", "→カテゴリ登録画面で「基本情報」というカテゴリを作成し、その中に「生年月日を入力してください」という質問を登録する"], button: {name: "カテゴリを作成・編集する", url:"/part_groups/index"}},
    {title: "２，３を繰り返して、カテゴリを増やしていく", descripts: ["住所を聞きたい→「ご住所は？」という質問を作成し、カテゴリ「基本情報」に登録する", "アレルギー歴を聞きたい→「アレルギーはありますか？」という質問を作成","「体質・副作用」というカテゴリを新たに作成し、質問を登録する"], button: {name: null, url: null}},
    {title: "カテゴリを集めてアンケートを作成する", descripts: ["アンケート登録画面で「男性」というアンケートを作成", "「基本情報」「体質・副作用」というカテゴリを登録する"], button: {name: "アンケートを作成・編集する", url:"/templates/index"}},
    {title: "作成したアンケートを表示する", descripts: ["店舗毎に表示したいアンケートを選択する。"], button: {name: "アンケート表示設定", url:"/template_owners/display_settings"}}
  ]
  return(
    <>
        <h3 className="h3">アンケート構成</h3>
        <ul className="ul-padding">
            <h5><li className="bold">複数の「質問」がまとまって「カテゴリ」が構成されています。</li></h5>
            <h5><li className="bold">複数の「カテゴリ」がまとまって「アンケート」が構成されています。</li></h5>
        </ul>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 help-image-area">
          <img src={img} className="w70p" alt="アイコン"></img>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-right mb20">
          <a className="btn btn-primary"data-toggle="modal" data-target="#interview_img">患者にはこのように表示されます</a>
        </div>
        <br/>

        <h3 className="h3">アンケート作成手順</h3>
        <div className="col-md-12 col-xs-12">
          <h3 className="red">管理者以外使用しないでください。<br/>アンケートを表示するには店舗毎にアンケート表示設定をしてください。<br/>※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。</h3>
        </div>
        {
          exsamples.map((exsample, exsample_count) => 
            <>
              <div className="row help-exsample-title">
                <h3 className="col-xs-1 col-sm-1 col-md-1 col-lg-1 help-no-width">{exsample_count + 1}</h3>
                <h5 className="col-xs-11 col-sm-11 col-md-11 col-lg-11 bold">{exsample.title}</h5>
              </div>
              {
                exsample.descripts.map((descript, descript_count) =>
                  <>
                    <div className="row">
                      {descript_count === 0 ? <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right">例</div> : <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right"/>}
                      <div className="col-xs-10 col-sm-6 col-md-7 col-lg-7">{descript}</div>
                      <div className="col-xs-12 col-sm-4 col-md-3 col-lg-3 text-center">
                        {exsample.descripts.length === descript_count + 1 && exsample.button.name != null ?
                          <a className="btn btn-primary" href={exsample.button.url}>{exsample.button.name}</a> : <></>
                        }
                      </div>
                    </div>
                  </>
                )
              }
              <hr className="hr-margin-10"/>
            </>
          )
        }
      {/* アンケートサンプル表示 */}
      <div id="interview_img" className="modal fade" role="dialog">
        <div className="modal-dialog modal-w80">
          <div className="modal-content">
            <div className="modal-body text-center">
                <img src={interview_img} className="w70p" alt="アンケートサンプル"/>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Index;